import { useState } from 'react';

interface FilterBarProps {
  onClick: () => void;
  label?: string;
  filterCount?: number;
  isOpen?: boolean;
  /** Fixed width in px (e.g. Figma 97). When set, button uses this width. */
  width?: number;
  /** Fixed height in px (e.g. Figma 48). When set, button uses this height. */
  height?: number;
}

export function FilterBar({
  onClick,
  label = 'Filtruj',
  filterCount = 0,
  width,
  height,
}: FilterBarProps) {
  const [isPressed, setIsPressed] = useState(false);

  const handleMouseDown = () => {
    setIsPressed(true);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const handleClick = () => {
    onClick();
  };

  const sizeStyle =
    width !== undefined || height !== undefined
      ? {
          ...(width !== undefined && { width: `${width}px` }),
          ...(height !== undefined && { height: `${height}px` }),
        }
      : undefined;

  return (
    <button
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      className={`flex items-center justify-center rounded-lg border border-[#DCDDE0] px-4 py-2.5 gap-2 cursor-pointer relative overflow-visible transition-all duration-200 ease-in-out hover:bg-[#E8EEF0] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#181A1B] ${width === undefined && height === undefined ? 'h-10' : ''}`}
      style={sizeStyle}
      data-testid="filter-bar-button"
    >
      {/* Inset shadow overlay - only on right half */}
      {isPressed && (
        <div
          className="absolute right-0 bottom-0 z-0 pointer-events-none"
          style={{
            width: '80%',
            height: '80%',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#181A1B1A',
            borderRadius: '40px 40px 0px 0px',
          }}
        />
      )}
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        className="relative z-10"
      >
        <path
          d="M18.3334 2.5H1.66675L8.33341 10.3833V15.8333L11.6667 17.5V10.3833L18.3334 2.5Z"
          stroke="#474A4C"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="text-[#474A4C] text-sm font-medium leading-5 tracking-[0.1px] relative z-10">
        {label}
      </span>
      {filterCount > 0 && (
        <div className="absolute -top-1 -right-1 w-5 h-5 bg-[#FFCC00] rounded-full flex items-center justify-center z-20">
          <span className="text-[#181A1B] text-[11px] font-medium leading-4 tracking-[0.5px] text-center">
            {filterCount}
          </span>
        </div>
      )}
    </button>
  );
}
